/* global axios */
import ApiClient from './ApiClient';

class NativeAttributesRequirementsApi extends ApiClient {
  constructor() {
    super('native_attribute_requirements', { accountScoped: true });
  }

  getRequirements() {
    return axios.get(`${this.url}`);
  }

  create(key) {
    return axios.post(this.url, { key });
  }

  delete(native_attribute_requirement_id) {
    return axios.delete(`${this.url}/${native_attribute_requirement_id}`);
  }
}

export default new NativeAttributesRequirementsApi();
